import firebase from 'firebase/app'
import "firebase/auth"

export const auth  = firebase.initializeApp({
        apiKey: "AIzaSyDMIa356WinB315fwZSEPITjypTTiMnEyc",
        authDomain: "unichat-4d783.firebaseapp.com",
        projectId: "unichat-4d783",
        storageBucket: "unichat-4d783.appspot.com",
        messagingSenderId: "1021487312709",
        appId: "1:1021487312709:web:c2e5451342417c9e82182c"
}).auth();